<template>
  <div style=" width: 1200px; margin: 0 auto; background-color: #F2F6FC;  ">
    <Title :title="{name: '用章申请', path:'/item'}"></Title>


    <el-card class="box-card" style="min-height: 650px;margin-top: 15px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="left" label-width="150px">

        <el-divider content-position="left">文件信息</el-divider>

        <el-form-item label="盖章类型" prop="hasProject" required>
          <el-radio-group v-model="ruleForm.hasProject">
            <el-radio label="1">项目盖章</el-radio>
            <el-radio label="2">文件盖章</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item v-if="ruleForm.hasProject ==1" label="项目名称" required
                      prop="projectId">
          <el-select style="width: 360px" v-model="ruleForm.projectId"
                     placeholder="请选择需要盖章的项目"
                     filterable>
            <el-option
                v-for="item in projectList"
                :key="item.projectId"
                :label="item.projectName"
                :disabled="item.projectState === 6"
                :value="item.projectId">
                <span style="float: left">{{ item.projectName }}&nbsp&nbsp{{item.projectIden}}</span>&nbsp&nbsp
                <el-tag v-if="item.projectState === 6" type="info" size="mini">S: 已终止</el-tag>
                <span style="float: left">&nbsp&nbspM: {{ item.managerName }}</span>
            </el-option>
          </el-select>
        </el-form-item>

        <div v-if="ruleForm.hasProject ==2">

          <el-form-item label="文件名称" prop="fileName">
            <el-input v-model="ruleForm.fileName">
            </el-input>
          </el-form-item>

          <el-form-item label="文件份数" prop="fileName">
            <el-input-number v-model="ruleForm.fileNum" :min="1" :max="100"></el-input-number>
          </el-form-item>
        </div>

        <el-form-item label="用章文件" >
          <el-upload
              class="upload-demo"
              drag
              action=""
              :multiple=false
              :limit="1"
              :on-exceed="handleExceed"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              accept=".jpg, .jpeg, .png, .doc, .docx, .pdf, .ofd, .zip, .rar"
              :on-change="handleFileChange"
              :file-list="fileList"
              :http-request="uploadSectionFile"
              :before-upload="beforeUpload"
              list-type="picture">

            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">只能上传word/pdf/ofd/jpg/png/jpeg/zip/rar文件，且不超过40M</div>
          </el-upload>
          <el-alert
            title="pdf文件现已支持在线预览"
            type="info">
          </el-alert>
        </el-form-item>

        <el-divider content-position="left">用章信息</el-divider>


        <el-form-item label="用章时间" prop="useTime" required>
          <el-date-picker
              v-model="ruleForm.useTime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="pickerDateOpts"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="章子外出" prop="sealOut" required>
          <el-radio-group v-model="ruleForm.sealOut">
            <el-radio label="1">否</el-radio>
            <el-radio label="2">是</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="章子类别" prop="sealTypeArray" required>
          <el-checkbox-group v-model="ruleForm.sealTypeArray">
            <el-checkbox label="1">公章</el-checkbox>
            <el-checkbox label="2">合同章</el-checkbox>
            <el-checkbox label="3">法人章</el-checkbox>
            <el-checkbox label="4">财务章</el-checkbox>
            <el-checkbox label="5">发票章</el-checkbox>
            <el-checkbox label="6">营业执照</el-checkbox>
            <el-checkbox label="7">法人身份证原件</el-checkbox>
            <el-checkbox label="8">法人身份复印件</el-checkbox>
          </el-checkbox-group>
        </el-form-item>


        <el-form-item label="用章事由" prop="reason">
          <el-input type="textarea" rows="5" maxlength="500" show-word-limit
                    v-model="ruleForm.reason"></el-input>
        </el-form-item>


        <el-Form-item>
          <el-button v-if="submitShow" type="primary" @click="submitForm('ruleForm')">提交申请</el-button>
        </el-Form-item>

      </el-form>


    </el-card>
  </div>


</template>

<script>
import Title from "../../Title";
import {digitUppercase, isNum} from "../../../util";
import {
  requestAllProject,
  requestSealApply,
  requestApplyDetail
} from "../../../api";

export default {
  components: {Title},
  name: "SealApply",
  data() {
    const validatePrice = (rule, value, callback) => {
      if (!value) {
        callback(new Error("金额不能为空"));
      } else if (!isNum(value)) {
        callback(new Error("请输入正确格式的金额"));
      } else if (value.split(".").length > 2) {
        callback(new Error("请输入正确格式的金额")); //防止输入多个小数点
      } else if (value.indexOf(".") > -1 && value.substring(value.indexOf(".") + 1).length > 2) {
        callback(new Error("最大保留两位小数"));
      } else if (value.length > 12) {
        callback(new Error("长度最大12个字符"))
      } else {
        this.ruleForm.costMoney = value
        callback();
      }
    };
    const start = new Date();
    const end = new Date().getTime() + 3600 * 1000 * 24 * 1;
    return {

      submitShow: true,

      dialogVisible: false,
      projectList: [],
      fileList: [],

      applyServiceId: "",
      applyType: "",
      applyId: null,
      sealId: "",
      reapply: false,

      ruleForm: {
        hasProject: "1",
        projectId: "",
        fileName: "",
        fileNum: 1,
        useTime: [],
        sealOut: "1",
        sealTypeArray: [],
        reason: "",


      },
      rules: {
        projectId: [
          {required: true, message: '请选择项目', trigger: 'blur'},
        ],
        fileName: [
          {required: true, message: '请输入文件名称', trigger: 'blur'},
          {max: 50, message: '长度最大50个字符', trigger: 'blur'}
        ],
        useTime: [
          {required: true, message: '请选择用章时间', trigger: 'blur'},
        ],
        sealTypeArray: [
          {required: true, message: '请选择用章类型', trigger: 'blur'},
        ],
        reason: [
          {required: true, message: '请输入用章事由', trigger: 'blur'},
          {max: 500, message: '长度最大500个字符', trigger: 'blur'}
        ],


      },
      pickerDateOpts: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },

    }

  },
  computed: {},
  created() {
    this.applyId = this.$route.query.applyId
    this.applyServiceId = this.$route.query.applyServiceId
    this.applyType = this.$route.query.applyType
    if (this.applyId || this.applyServiceId || this.applyType) {
      this.reapply = true
      this.getObject()
    }

    this.getAllProject()
  },
  methods: {


    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let formData = new FormData()

          if (this.ruleForm.hasProject == 1) {
            //data.projectId = this.ruleForm.projectId
            formData.append("projectId", this.ruleForm.projectId)
          }
          if (this.ruleForm.hasProject == 2) {
            // data.fileName = this.ruleForm.fileName
            // data.fileNum = this.ruleForm.fileNum
            formData.append("fileName", this.ruleForm.fileName)
            formData.append("fileNum", this.ruleForm.fileNum)
          }
          formData.append("beginTime", this.ruleForm.useTime[0])
          formData.append("endTime", this.ruleForm.useTime[1])
          formData.append("sealType", this.ruleForm.sealTypeArray.toString())
          formData.append("reason", this.ruleForm.reason)
          formData.append("hasProject", this.ruleForm.hasProject)
          formData.append("sealOut", this.ruleForm.sealOut)

          // 重新申请需要的参数
          if (this.reapply) {
            if (this.ruleForm.hasProject == 1) {
              formData.append("fileNum", 0)
            }
            if (this.ruleForm.hasProject == 2) {
              formData.append("projectId", '0')
            }
            formData.append("sealId", this.sealId)
            formData.append("applyId", this.applyId)
            formData.append("reapply", this.reapply)
          }

          // data.beginTime = this.ruleForm.useTime[0]
          // data.endTime = this.ruleForm.useTime[1]
          // data.sealType = this.ruleForm.sealTypeArray.toString()
          // data.reason = this.ruleForm.reason
          // data.hasProject = this.ruleForm.hasProject
          // data.sealOut = this.ruleForm.sealOut
          if (this.fileList && this.fileList.length > 0) {
            formData.append("file", this.fileList[0].raw)
            const size = 1024 * 1024 * 40
            if (this.fileList[0].size > size) {
              this.$message.error("文件大小不能超过40MB")
              return
            }
          } else if (!this.reapply){
//            this.$message.error("请上传用章文件")
//            return
          }

          this.submitShow = false

          requestSealApply(formData).then(res => {
            if (res.code == 200) {
              this.$message.success(res.msg);
              // 重新申请完之后清空路径参数
              if (this.reapply) {
                this.$router.push({query: {}})
                this.reapply = false
              }
              this.resetForm('ruleForm')
              this.fileList = []
              this.submitShow = true
            } else {
              this.$message.error(res.msg);
              this.submitShow = true
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    getObject() {
      requestApplyDetail({
        applyId: this.applyId,
        applyServiceId: this.applyServiceId,
        applyType: this.applyType
      }).then(res => {
        if (res.code == 200) {
          if (res.object) {
            let detail = res.object.detail
            this.sealId = detail.sealId

            this.ruleForm.fileName = detail.fileName
            this.ruleForm.projectId = detail.projectId
            this.ruleForm.fileNum = detail.fileNum
            this.ruleForm.reason = detail.reason
            this.ruleForm.hasProject = detail.hasProject.toString()
            this.ruleForm.sealOut = detail.sealOut.toString()

            let useTime = []
            useTime.push(detail.beginTime)
            useTime.push(detail.endTime)
            this.ruleForm.useTime = useTime
            this.ruleForm.sealTypeArray = detail.sealType.split(',')
            const file = {
              name: detail.fileOriginalName,
              url: require('@/assets/word.png')
            }
            this.fileList.push(file)
          }
        } else {
          this.$message.error(res.msg);
        }
      })
    },


    // 查询所有项目
    getAllProject() {
      requestAllProject({}).then(res => {
        if (res.code == 200) {
          if (res.object) {
            this.projectList = res.object
          }
        } else {
          this.$message.error(res.msg);
        }
      })
    },

    handleExceed(files, fileList) {
      this.$message.warning('只能上传1个文件')
    },
    // 上传文件
    uploadSectionFile(file) {

    },
    // 文件修改
    handleFileChange(file, fileList) {
      this.fileChange = true
      file.url = require('@/assets/word.png')
      console.log(file)
      this.fileList.push(file)
    },
    // 移除
    handleRemove(file, fileList) {
      this.fileChange = true
      this.fileList = []
    },
    // 预览
    handlePreview(file) {
      console.log(file);
    },
    beforeUpload(file) {

    },


    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
}
</script>

<style scoped>

</style>




